export const filterDefaultState = {
    filters: []
}

export enum FilterAction {
    RESET,
    CHANGE_FILTER,
    SET_ID_FILTER,
    LOAD_FROM_FACET_ENDPOINT,
    TRIGGER_RESET, // May or may not need this, restructure might take care of weirdness we had before
    ADD_FILTER_COUNTS,
}

type Term = {
    term: string,
    displayName: string,
    enabled: boolean,
    count: number
}

type Filter = {
    fieldName: string,
    displayName: string,
    searchFields: string[]
    terms: Term[]
}

type FilterState = {
    filters: Filter[]
}


export const filterReducer = (state: FilterState, payload): FilterState => {
    switch (payload.action) {
        case FilterAction.RESET: {
            return {
                ...state,
                filters: state.filters.map(filter => {
                    return {
                        ...filter,
                        terms: filter.terms.map(term => {
                            return {
                                ...term,
                                count: 0,
                                enabled: false
                            }
                        })
                    }
                })
            };
        }


        case FilterAction.CHANGE_FILTER: {
            let newFilters = [...state.filters];
            for (let facet of newFilters) {
                if (facet.fieldName === payload.filter) {
                    for (let t of facet.terms) {
                        if (t.term === payload.term) {
                            t.enabled = payload.enabled;
                        }
                    }
                }
            }
            const idFilter = [...state.filters.filter(f => f.fieldName == 'id')];
            newFilters = newFilters.filter(f => f.fieldName != 'id');
            newFilters.push(idFilter[0]);

            return {
                ...state,
                filters: newFilters
            };
        }

        case FilterAction.SET_ID_FILTER: {
            let newTerms = payload.ids.map(id => ({
                term: '' + id,
                enabled: true,
                displayName: id
            }));
            if (payload.ids.length == 0) {
                newTerms.push({
                    term: 'fakeid',
                    enabled: true,
                    displayName: 'fakeid'
                })
            }

            //let tempFilters = filtersToModify ? [...filtersToModify] : [...filterSet];
            let tempFilters = [...state.filters];
            for (let filter of tempFilters) {
                if (filter.fieldName === 'id') {
                    filter.terms = newTerms
                }
            }

            return {
                ...state,
                filters: tempFilters
            };
        }

        case FilterAction.LOAD_FROM_FACET_ENDPOINT: {
            let filters = payload.facets.map(facet => ({
                fieldName: facet.fieldName.replace('Facets.', ''),
                displayName: facet.displayName,
                description: facet.description,
                searchFields: facet.searchFields.map(f => f.replace('Facets.', '')),
                terms: facet.terms.map(term => ({
                    term: term.term,
                    displayName: term.displayName,
                    enabled: term.selected,
                    count: 0
                }))
            }));
            filters.push({
                fieldName: 'id',
                terms: [],
                displayName: 'id',
                searchFields: ['id']
            });
            return {
                ...state,
                filters: filters
            };
        }


        case FilterAction.TRIGGER_RESET: {
            return { ...state };
        }

        case FilterAction.ADD_FILTER_COUNTS: {
            return { ...state };
        }
    }
}